import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  Button,
  VStack,
  Spacer,
  Grid,
  Badge,
  Icon,
  Avatar,
  SimpleGrid,
  Card,
  CardBody,
  CardFooter,
  Heading,
  HStack,
  useColorModeValue,
  CloseButton,
} from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { FaClock, FaSync } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Line, Bar } from "react-chartjs-2";
import Gr from "./Gr";
import {
  FaExclamationCircle,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import NoticeBoard from "../Admin/NoticeBoard";
import axios from "axios";
import Icons from "../../images/company logo.jpg";
import EventBoard from "../Admin/EventBoard";
import Component_bus from "./Student_detail/Component_bus";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const [date, setDate] = useState(new Date());
  const [timetableData, setTimetableData] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [examList, setExamList] = useState([]);
  const [facultyList, setFacultyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = sessionStorage.getItem("user_id"); // Retrieve user ID from session
  const userType = sessionStorage.getItem("user_type");

  const leaveData = [
    {
      type: "Emergency Leave",
      date: "15 Jun 2024",
      status: "Pending",
      statusColor: "blue",
      icon: FaExclamationCircle,
    },
    {
      type: "Medical Leave",
      date: "15 Jun 2024",
      status: "Approved",
      statusColor: "green",
      icon: FaCheckCircle,
    },
    {
      type: "Medical Leave",
      date: "16 Jun 2024",
      status: "Declined",
      statusColor: "red",
      icon: FaTimesCircle,
    },
    {
      type: "Not Well",
      date: "16 Jun 2024",
      status: "Approved",
      statusColor: "green",
      icon: FaCheckCircle,
    },
  ];

  useEffect(() => {
    const fetchFacultyMembers = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/student/subject_list.php`,
          {
            pass: userId, // Pass user_id in the request body
          }
        );

        console.log("====================================");
        console.log(response);
        console.log("====================================");

        if (response.data.success) {
          // Ensure response data contains a valid array
          if (Array.isArray(response.data.subjects)) {
            setFacultyList(response.data.subjects);
          } else {
            console.error("Unexpected data structure:", response.data.data);
          }
        } else {
          console.error("API call unsuccessful:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching faculty members:", error);
      }
    };

    fetchFacultyMembers();
  }, [userId]); // Add userId as a dependency

  useEffect(() => {
    // Fetch the exam list from the API
    const fetchExams = async () => {
      try {
        const userId = sessionStorage.getItem("user_id"); // Retrieve user ID from session
        const response = await axios.post(
          `${BASE_URL}/student/list_exams.php`,
          { pass: userId }
        );

        console.log("====================================");
        console.log(response);
        console.log("====================================");

        if (response.data.success) {
          setExamList(response.data.data); // Assuming the exams are in the data field
        }
      } catch (error) {
        console.error("Error fetching exam list:", error);
      }
    };

    fetchExams();
  }, []);

  const [examData, setExamData] = useState({
    labels: [], // Subjects or Exams
    datasets: [
      {
        label: "Minimum Marks",
        data: [], // Minimum marks
        borderColor: "red",
        backgroundColor: "red", // Light red color for the bars
        fill: false,
      },
      {
        label: "Maximum Marks",
        data: [], // Maximum marks
        borderColor: "green",
        backgroundColor: "green", // Light green color for the bars
        fill: false,
      },
      {
        label: "Student Marks",
        data: [], // Student's marks
        borderColor: "blue",
        backgroundColor: "blue", // Light blue color for the bars
        fill: false,
      },
    ],
  });

  // Rest of the code remains the same

  useEffect(() => {
    // Fetch data from the API
    const user_id = sessionStorage.getItem("user_id");

    fetch(`${BASE_URL}/student/exam_result_graph.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pass: user_id }),
    })
      .then((response) => response.json()) // parse the JSON response
      .then((data) => {
        console.log("Fetched Data:", data); // Log the data for debugging

        if (data.success) {
          // Process the data to match the structure of examData
          const labels = data.data.map((item) => item.subject); // Subjects
          const minMarks = data.data.map((item) => item.pass_mark);
          const maxMarks = data.data.map((item) => item.max_marks);
          const studentMarks = data.data.map(
            (item) => item.student_scored_marks
          );

          // Update state with the fetched data
          setExamData({
            labels,
            datasets: [
              {
                label: "Minimum Marks",
                data: minMarks,
                borderColor: "red",
                fill: false,
              },
              {
                label: "Maximum Marks",
                data: maxMarks,
                borderColor: "green",
                fill: false,
              },
              {
                label: "Student Marks",
                data: studentMarks,
                borderColor: "blue",
                fill: false,
              },
            ],
          });
        } else {
          console.error("No data found");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []); // Empty dependency array ensures this runs once when the component mounts

  useEffect(() => {
    const storedStudentId = sessionStorage.getItem("user_id");
    if (storedStudentId) {
      setStudentId(storedStudentId);
    }

    const fetchTimetable = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/timetable/list_timetable_to_student.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ pass: studentId }),
          }
        );
        const data = await response.json();
        console.log("====================================");
        console.log(data);
        console.log("====================================");
        if (data.success) {
          setTimetableData(data.timeTable || []);
        } else {
          console.error("Error fetching timetable:", data.message);
        }
      } catch (error) {
        console.error("Error fetching timetable:", error);
      }
    };

    fetchTimetable();
  }, [studentId]);

  const getStatus = (fromTime, toTime) => {
    const now = new Date();

    // Parse the start_time and end_time into Date objects using the 12-hour format with AM/PM
    const fromTimeDate = new Date(`${now.toDateString()} ${fromTime}`);
    const toTimeDate = new Date(`${now.toDateString()} ${toTime}`);

    // console.log('Current Time:', now);
    // console.log('From Time:', fromTimeDate);
    // console.log('To Time:', toTimeDate);

    // Compare times
    if (now > toTimeDate) {
      return "Completed";
    } else if (now >= fromTimeDate && now <= toTimeDate) {
      return "In Progress";
    } else {
      return "Upcoming";
    }
  };

  const currentDay = new Date().getDay(); // Adjust for your API's day_id values

  const filteredTimetableData = timetableData.filter(
    (classItem) => classItem.day_id === currentDay.toString()
  );

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/student/all_profile.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_type: userType, user_id: userId }),
          }
        );
        console.log("profile====================================");
        console.log(response);
        console.log("profile====================================");
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setUserData(data.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [userType, userId]);

  const bg = useColorModeValue("green.50", "green.900");
  const borderColor = useColorModeValue("green.400", "green.500");
  return (
    <Box bg="#f7fafc" minHeight="100vh">
      <div
        style={{ backgroundColor: "#FBFBFD", height: "230vh", padding: "20px" }}
      >
        <div className="teacher-list-container">
          <div className="header">
            <h1 fontSize="20px">Student Dashboard</h1>
            <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md" // Applies a medium shadow
                backgroundColor="white"
                fontSize="11px"
                onClick={() => {
                  // Add refresh functionality here
                  console.log("Refresh button clicked");
                }}
                display={{ base: "none", md: "flex" }}
              >
                <FaSync color="#515B73" />
              </Button>

              {/* <div className="export-dropdown">
                                <Button className="export-button" backgroundColor='white' fontSize='11px' boxShadow="md">
                                    <FaPrint color='#515B73' />
                                    Print PDF
                                </Button>
                            </div> */}
            </div>
          </div>

          <div className="breadcrumb">
            <span>Student</span> / <span>Dashboard</span>
          </div>
        </div>
        <div p={{ base: 0, md: 6 }}>
          <Box p={4}>
            <Flex
              alignItems="center"
              justifyContent="space-between"
              p={2}
              bg={bg}
              borderWidth="1px"
              borderColor={borderColor}
              borderRadius="full"
            >
              <Flex alignItems="center">
                <Avatar
                  size="sm"
                  src={Icons} // Replace with actual avatar URL or remove for a default avatar
                  mr={3}
                />
                <Box>
                  <Text fontSize="sm">
                    <Text as="span" fontWeight="bold" color="green">
                      Empowering businesses with tailored tech solutions
                    </Text>{" "}
                    {/* has paid Fees for the{" "}
                                            <Text as="span" fontWeight="bold" color="teal.500">
                                                “Term1”
                                            </Text> */}
                  </Text>
                </Box>
              </Flex>
              <CloseButton />
            </Flex>
          </Box>
          <div>
            <Box
              bgGradient="linear(to-r, blue.500, blue.600)"
              p={6}
              borderRadius="lg"
              color="white"
              position="relative"
              overflow="hidden"
            >
              <Flex alignItems="center" borderRadius="md" p={4}>
                {/* Left Side - User Info */}
                <Avatar
                  size="xl"
                  name={userData?.name}
                  src={userData?.image_url}
                  mr={6}
                />
                <VStack align="start" spacing={2}>
                  <Text fontWeight="bold" fontSize="2xl">
                    {userData?.name}
                  </Text>
                  <Text fontSize="lg">Classes: {userData?.class}</Text>
                  <Text fontSize="lg">
                    Admission No: {userData?.admission_number}
                  </Text>
                </VStack>

                {/* Spacer to push the next section to the right */}
                <Spacer />

                {/* Right Side - Bus Info */}
                {/* <Grid
                  templateColumns="repeat(2, 1fr)"
                  gap={6}
                  alignItems="baseline"
                  ml={6}
                >
                  <Text fontWeight="bold" fontSize="xl" gridColumn="span 2">
                    Bus Information
                  </Text>
                  <Text fontSize="lg">Bus No: {userData?.bus_number}</Text>
                  <Text fontSize="lg">Route: {userData?.route}</Text>
                  <Text fontSize="lg">
                    Pickup Point: {userData?.pickup_point}
                  </Text>
                  <Text fontSize="lg">Drop Point: {userData?.drop_point}</Text>
                </Grid> */}
                <Component_bus  />
              </Flex>
            </Box>
          </div>
          <Flex mb={6} direction={{ base: "column", md: "row" }} mt={5}>
            {/* Left Side */}
            <Flex direction="column" flex="2" mr={{ base: 0, md: 8 }} gap={6}>
              {/* Profile Section */}
              <NoticeBoard />
              <EventBoard />

              {/* Timetable */}
              <Box
                bg="white"
                p={6}
                borderRadius="lg"
                borderWidth="1px"
                overflowY="auto"
              >
                <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.600">
                  Today's Timetable
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                  {filteredTimetableData.length > 0 ? (
                    filteredTimetableData.map((classItem, index) => (
                      <Card
                        key={index}
                        bg="gray.50"
                        boxShadow="sm"
                        _hover={{
                          boxShadow: "lg",
                          transform: "translateY(-2px)",
                          transition: "0.3s",
                        }}
                      >
                        <CardBody>
                          <Flex
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <VStack align="start">
                              <Heading size="md">{classItem.subject}</Heading>
                              <Text color="gray.600">
                                <Icon as={FaClock} mr={2} />
                                {classItem.start_time} - {classItem.end_time}
                              </Text>
                            </VStack>
                            <Badge
                              colorScheme={
                                getStatus(
                                  classItem.start_time,
                                  classItem.end_time
                                ) === "Completed"
                                  ? "green"
                                  : getStatus(
                                      classItem.start_time,
                                      classItem.end_time
                                    ) === "In Progress"
                                  ? "yellow"
                                  : "blue"
                              }
                              variant="solid"
                            >
                              {getStatus(
                                classItem.start_time,
                                classItem.end_time
                              )}
                            </Badge>
                          </Flex>
                        </CardBody>
                      </Card>
                    ))
                  ) : (
                    <Text>No classes scheduled for today.</Text>
                  )}
                </SimpleGrid>
              </Box>

              <Box
                bg="white"
                p={6}
                borderRadius="lg"
                borderWidth="1px"
                mt={6}
                display={{ base: "none", md: "block" }}
              >
                <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.600">
                  Exam Results
                </Text>
                <div style={{ height: "400px", width: "100%" }}>
                  <Bar data={examData} />
                </div>
              </Box>

              {/* <Gr /> */}
            </Flex>

            {/* Right Side */}
            <Flex direction="column" flex="1" gap={8}>
              {/* Exam List */}
              <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
                <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.600">
                  Upcoming Exams
                </Text>
                <SimpleGrid columns={1} spacing={4}>
                  {examList.map((exam, index) => (
                    <Card
                      key={index}
                      bg="gray.50"
                      boxShadow="sm"
                      _hover={{
                        boxShadow: "lg",
                        transform: "translateY(-2px)",
                        transition: "0.3s",
                      }}
                    >
                      <CardBody>
                        <Text fontSize="lg" fontWeight="bold">
                          {exam.subject}
                        </Text>
                        <Text color="gray.600">Date: {exam.exam_date}</Text>
                        <Text color="gray.600">
                          Max Marks: {exam.max_marks}
                        </Text>
                      </CardBody>
                    </Card>
                  ))}
                </SimpleGrid>
              </Box>

              {/* Faculty List */}
              <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
                <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.600">
                  Faculty Members
                </Text>
                {facultyList.length > 0 ? (
                  facultyList.map((faculty, index) => (
                    <Flex
                      key={index}
                      mb={4}
                      alignItems="center"
                      _hover={{
                        bg: "gray.50",
                        transform: "scale(1.02)",
                        transition: "0.3s",
                      }}
                      p={4}
                      borderRadius="md"
                      boxShadow="sm"
                    >
                      <Avatar
                        name={faculty.teacher_name}
                        src={faculty.image_url}
                        size="lg"
                        mr={4}
                      />
                      <VStack align="start" spacing={1}>
                        <Text fontWeight="bold">{faculty.teacher_name}</Text>
                      </VStack>
                    </Flex>
                  ))
                ) : (
                  <Text color="gray.500">No faculty members available.</Text>
                )}
              </Box>

              {/* <NoticeBoard /> */}

              {/* <Box p={5} shadow="md" borderWidth="1px" borderRadius="md" width="100%" maxWidth="500px">
                <Text fontSize="xl" fontWeight="bold" mb={4}>Leave Status</Text>
                <VStack spacing={4} align="stretch">
                  {leaveData.map((leave, index) => (
                    <Box key={index} p={4} borderRadius="md" borderWidth="1px" bg="gray.50">
                      <HStack justifyContent="space-between">
                        <HStack>
                          <Icon as={leave.icon} color={leave.statusColor + ".500"} boxSize={5} />
                          <Text fontWeight="bold">{leave.type}</Text>
                        </HStack>
                        <Badge colorScheme={leave.statusColor} variant="solid">
                          {leave.status}
                        </Badge>
                      </HStack>
                      <Text color="gray.500">Date: {leave.date}</Text>
                    </Box>
                  ))}
                </VStack>
              </Box> */}

              {/* Calendar */}
              <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
                <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.500">
                  Schedules
                </Text>
                <Box
                  bg="gray.50"
                  borderRadius="md"
                  p={4}
                  border="1px solid #e2e8f0"
                  boxShadow="md"
                  maxW="100%"
                  overflow="hidden"
                  sx={{ width: "auto" }}
                >
                  <Calendar
                    onChange={setDate}
                    value={date}
                    tileClassName={({ date, view }) =>
                      view === "month" &&
                      date.getDate() === new Date().getDate()
                        ? "react-calendar__tile--active"
                        : undefined
                    }
                  />
                  <style jsx global>{`
                    .react-calendar {
                      font-family: "Poppins", sans-serif;
                      border: none;
                      width: auto;
                    }
                    .react-calendar_month-viewdays_day {
                      font-family: "Poppins", sans-serif;
                    }
                    .react-calendar__tile {
                      font-family: "Poppins", sans-serif;
                      border-radius: 4px;
                      padding: 10px;
                      transition: background-color 0.3s;
                    }
                    .react-calendar__tile--active {
                      background-color: #3182ce;
                      color: white;
                      border-radius: 4px;
                    }
                    .react-calendar__tile:hover {
                      background-color: #ebf8ff;
                    }
                  `}</style>
                </Box>
              </Box>
            </Flex>
          </Flex>
        </div>
      </div>
    </Box>
  );
};

export default Dashboard;
